import { useQuery, useQueryClient, useMutation } from "@tanstack/react-query";
import { Manufacturer } from "../types";
import { get, post } from "../services/restClient";
import { Endpoint, setEndpoint } from "../services/endpoints";

export interface CreateManufacturer {
    name: string;
    soecoId: string;
}

const getManufacturers = async () => {
    const data = await get<Manufacturer[]>(setEndpoint(Endpoint.manufacturers), {
        requireAuth: true,
    });
    return data;
};

export const useGetManufacturers = () => {
    return useQuery({ queryKey: ["manufacturers"], queryFn: () => getManufacturers() });
};

const postManufacturer = async (manufacturer: CreateManufacturer) => {
    const data = await post<CreateManufacturer, Manufacturer>(
        setEndpoint(Endpoint.manufacturers),
        manufacturer,
        { requireAuth: true },
    );
    return data;
};

export const useAddManufacturer = () => {
    const queryClient = useQueryClient();

    return useMutation({
        mutationFn: async (manufacturer: CreateManufacturer) => {
            return postManufacturer(manufacturer);
        },
        onSuccess: () => {
            // Invalidera queryn så att vi får uppdaterade data
            void queryClient.invalidateQueries({ queryKey: ["manufacturers"] });
        },
    });
};
